import { useEffect, useState } from "react";
import { TabStyle } from "../../../TabsStyle/TabsStyle";
import StyleFillModal from "./StyleFillModal";
import StyleConfig from "./StyleConfig";
import checklistStyle, { modeloStyleType } from "../../../../service/checklistStyle";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { toast } from "react-toastify";
import AttToken from "../../../../helpers/attToken";
import { useTranslation } from "react-i18next";
import queryClient from "../../../../service/query";
import { initialObjectToSend } from "../../ChecklistStyle";
import HeaderModal from "../../../HeaderModal/HeaderModal";
import FooterModal from "../../../FooterModal/FooterModal";
import QueryFn from "../../../../helpers/QueryFn";

type props = {
  editing: boolean,
  setEditing: Function,
  openModal: boolean,
  setOpenModal: Function,
  setObjectToEdit: Function,
  objectToEdit: modeloStyleType,
};

const modelService = new checklistStyle();
const queryFn = new QueryFn();

export default function EditFormDeslogadoTabs({
  editing,
  setEditing,
  openModal,
  setOpenModal,
  objectToEdit,
  setObjectToEdit
}: props) {

  const mapNames = {
    style: 'Editar visual',
    config: 'Editar configurações'
  };

  const { t } = useTranslation('translation');

  const [isTab, setIsTab] = useState({
    isActiveObject: 'style',
    object: [
      'style',
      'config'
    ]
  });

  const toggleClass = (index: number) => {
    setIsTab({ ...isTab, isActiveObject: isTab.object[index] });
    trackEventMatomo('Configurar impressões form deslogado', 'click', 'tab', 'troca de abas');
  };

  const toggleActive = (index: number) => {
    if (isTab.object[index] === isTab.isActiveObject) {
      return "is-active";
    } else {
      return "inactve";
    }
  };

  const edit = queryFn.useMutate('EDIT_MODEL', async () => {
    try {
      toast.warn(`${t('toast.editingTemplate')}`);
      const token = await AttToken();
      if (token && objectToEdit) {
        const response = await modelService.edit(token, objectToEdit);
        queryClient.resetQueries({ queryKey: ['GET_MODELS'] });
        toast.success(`${t('toast.templateUpdated')}`);
        setObjectToEdit(initialObjectToSend);
        setOpenModal(false);
        setEditing(false);
        return response;
      }
    } catch (error) {
      console.error('Error editing model:', error);
    }
  });

  const create = queryFn.useMutate('CREATE_MODEL',
    async () => {
      try {
        toast.warn(`${t('toast.creatingNewTemplate')}`);
        const token = await AttToken();
        if (token && objectToEdit) {
          const response = await modelService.create(token, objectToEdit);
          queryClient.resetQueries({ queryKey: ['GET_MODELS'] });
          toast.success(`${t('toast.templateCreatedSuccess')}`);
          setObjectToEdit(initialObjectToSend);
          setOpenModal(false);
          return response;
        }
      } catch (error) {
        console.error('Error creating model:', error);
      }
    });

  const close = () => {
    setObjectToEdit(initialObjectToSend);
    setOpenModal(false);
    setEditing(false);
    trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'cancela');
  };

  const submit = () => {
    trackEventMatomo('Configurar impressões form deslogado', 'click', 'button', 'salva');
    !editing ?
      create.mutateAsync('')
      : edit.mutateAsync('');
  };

  const escape = (e: any) => {
    if (e.key === 'Escape') {
      close();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escape, true);
  }, [escape]);

  return (
    <div className={openModal ? "modal is-active" : "modal"}>
      <div className="modal-background" onClick={() => close()} onKeyDown={(e) => escape(e)} />
      <div className="modal-card" >
        <HeaderModal headerTitle="Criar layout para formulário web" close={close} />
        <div className="modal-card-body" style={{ padding: 0, paddingTop: 10 }}>
          <div style={{ width: '100%' }}>
            <div className="tabs is-boxed" style={{ padding: 0, paddingLeft: 10 }}>
              <ul>
                {isTab.object.map((el, index) => (
                  <li key={index} className={toggleActive(index)} onClick={() => { toggleClass(index); }}>
                    <TabStyle theme={toggleActive(index)}>{mapNames[el as keyof typeof mapNames]}</TabStyle>
                  </li>
                ))}
              </ul>
            </div>
            {isTab.isActiveObject === 'style' && (
              <StyleFillModal
                setObjectToEdit={setObjectToEdit}
                objectToEdit={objectToEdit}
              />
            )}
            {isTab.isActiveObject === 'config' && (
              <StyleConfig
                setObjectToEdit={setObjectToEdit}
                objectToEdit={objectToEdit}
              />
            )}
          </div>
        </div>
        <FooterModal
          label={`${t('save')}`}
          submit={submit}
          disabled={create.isPending || edit.isPending || !objectToEdit.associatedChecklists?.length} />
      </div>
    </div>
  );
}


